// mx 墨西哥
// s-cvf/s-cf for  subaccount? : 'https://s-cvf-tw.shopeesz.com/file',
const videoPathMap: Record<General.Region, string> = {
  id: 'https://cvf.shopee.co.id/file',
  vn: 'https://cvf.shopee.vn/file',
  tw: 'https://cvf.shopee.tw/file',
  th: 'https://cvf.shopee.co.th/file',
  my: 'https://cvf.shopee.com.my/file',
  ph: 'https://cvf.shopee.ph/file',
  sg: 'https://cvf.shopee.sg/file',

  br: 'https://cvf.shopee.com.br/file',
  cl: 'https://cvf.shopee.cl/file',
  co: 'https://cvf.shopee.com.co/file',
  mx: 'https://cvf.shopee.com.mx/file',
  pl: 'https://cvf.shopee.pl/file',
  es: 'https://cvf.shopee.com.es/file',
  fr: 'https://cvf.shopee.com.fr/file',
  gb: '',
};
const imagePathMap: Record<General.Region, string> = {
  id: 'https://cf.shopee.co.id/file',
  vn: 'https://cf.shopee.vn/file',
  tw: 'https://cf-tw.shopeesz.com/file/',
  th: 'https://cf.shopee.co.th/file',
  my: 'https://cf.shopee.co.my/file',
  ph: 'https://cf.shopee.ph/file',
  sg: 'https://cf.shopee.sg/file',
  br: 'https://cf.shopee.com.br/file',
  cl: 'https://cf.shopee.cl/file',
  co: 'https://cf.shopee.com.co/file',
  mx: 'https://cf.shopee.com.mx/file',
  pl: 'https://cf.shopee.com.pl/file',
  es: 'https://cf.shopee.com.es/file',
  fr: 'https://cf.shopee.com.fr/file',
  gb: '',
};

// https://s-cf-tw.shopeesz.com/file/1da5e14dac53cafbdf66d883d6607663_tn

export const videoUrlGenerator = (region: General.CaselessRegion, fileHash: string | number) =>
  `${videoPathMap[region.toLocaleLowerCase() as General.Region]}/${fileHash}`;
export const imageUrlGenerator = (region: General.CaselessRegion, fileHash: string | number) =>
  `${imagePathMap[region.toLocaleLowerCase() as General.Region]}/${fileHash}`;
